import styled from "styled-components";
import {Header, RingEmpty, RingFull} from "../landing.components";
import opinions from '../../../../opinions-data.json';
import {responsive} from "../../../../media-quries";
import { FaUserCircle } from "react-icons/fa";

const Container = styled.div`
  margin: 80px 0 0 0;
  padding: 24px 0;
  display: flex;
  position: relative;
  min-height: 600px;
  flex-direction: column;
  gap: 40px;
`;
const OpinionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${responsive.sm`
  gap: 60px;
  justify-content: center;
  `}
`;
const Opinion = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-basis: 31%;
  padding: 32px 24px 24px 24px;
  gap: 8px;
  height: fit-content;
  max-height: 350px;
  border-radius: 16px;
  

  ${responsive.sm`
  flex-basis: 75%;
  `}

  -webkit-box-shadow: 0px 0px 10px 0px rgba(205, 205, 205, 1);
  -moz-box-shadow: 0px 0px 10px 0px rgba(205, 205, 205, 1);
  box-shadow: 0px 0px 10px 0px rgba(205, 205, 205, 1);

  &:nth-child(2) {
    margin-top: 70px;
  }

  ${responsive.sm`
    margin-top: 0 !important;
  `}
`;
const OpinionAuthor = styled.p`
  text-align: center;
  line-height: 16px;
  font-weight: 600;
`;
const OpinionCity = styled.p`
  text-align: center;
  line-height: 16px;
  transform: skew(-10deg);
`;
const OpinionText = styled.p`
  flex: 1;
  justify-content: center;
  display: flex;
  position: relative;
  padding: 24px 0;
  
  &:before {
    transform: skew(-15deg);
    font-size: 32px;
    font-weight: bold;
    content: '"';
    position: absolute;
    top: 0;
    left: -12px;
  }
  &:after {
    transform: skew(-15deg);
    font-size: 32px;
    font-weight: bold;
    content: '"';
    position: absolute;
    bottom: 0;
    right: -12px;
  }
`;
const AvatarIcon = styled(FaUserCircle)`
  position: absolute;
  top: -40px;
  left: 0;
  right: 0;
  margin: auto;
`;
const Ring1 = styled(RingEmpty)`
  width: 120px;
  height: 120px;
  top: 0px;
  left: -50px;
`;
const Ring2 = styled(RingEmpty)`
  width: 90px;
  height: 90px;
  bottom: -80px;
  right: -50px;

  ${responsive.sm`
    display: none;
  `}
`;
const Ring3 = styled(RingFull)`
  width: 40px;
  height: 40px;
  top: 0;
  left: 60px;
`;

function Opinions() {
    const selectedOpinions = opinions.opinions
        .sort(() => Math.random() - 0.5)
        .slice(0, 3);

    return <Container>
        <Header>Co mówią o nas nasi klienci</Header>
        <OpinionsContainer>
            {selectedOpinions.map(({ author, city, text }) =>
                <Opinion>
                    <AvatarIcon size={60} />
                    <OpinionAuthor>{author}</OpinionAuthor>
                    <OpinionCity>{city}</OpinionCity>
                    <OpinionText>{text}</OpinionText>
                </Opinion>
            )}
        </OpinionsContainer>
        <Ring1 />
        <Ring2 />
        <Ring3 />
    </Container>
}

export default Opinions;
